import RoutingUtils from "@shared/routing/utils";
import { useRoutesSelector } from "@redux/reducers/appConfig";

export const useRoutingUtils = () => {
  const routes = useRoutesSelector();

  return new RoutingUtils({ routes });
};
